import Api from "app/services/common/Api";

import axios from "axios";
import { HeadersUtil } from "app/utils/headersUtil";
import * as process from "process";

export class ImplwayService extends Api {
  private static service: ImplwayService;
  private static REC_URL: string = process.env.REACT_APP_URL_CO + "/rec/re100";
  private static RPS_URL: string = process.env.REACT_APP_URL_CO + "/rec/rps";
  private static SMP_DAILY_URL: string =
    process.env.REACT_APP_URL_CO + "/smp/daily";
  private static GRPR_URL: string =
    process.env.REACT_APP_URL_CO + "/grpr/latest";
  private static GRPRDATA_URL: string = process.env.REACT_APP_URL_CO + "/grpr";

  public static getInstance(): ImplwayService {
    if (!ImplwayService.service) {
      ImplwayService.service = new ImplwayService();
    }
    return ImplwayService.service;
  }

  public async getRe100() {
    return (
      await axios.get(ImplwayService.REC_URL, {
        headers: HeadersUtil.getHeaders(),
      })
    ).data;
  }

  public async getRps() {
    return (
      await axios.get(ImplwayService.RPS_URL, {
        headers: HeadersUtil.getHeaders(),
      })
    ).data;
  }

  public async getSmpDaily() {
    return (
      await axios.get(ImplwayService.SMP_DAILY_URL, {
        headers: HeadersUtil.getHeaders(),
      })
    ).data;
  }

  public async getGrpr() {
    return (
      await axios.get(ImplwayService.GRPR_URL, {
        headers: HeadersUtil.getHeaders(),
      })
    ).data;
  }

  public async getGrprData() {
    return (
      await axios.get(ImplwayService.GRPRDATA_URL, {
        headers: HeadersUtil.getHeaders(),
      })
    ).data;
  }
}
